__webpack_require__.p = "/reports-dashboard-templates-boards-rename/referrals-hub/";